<script setup>

import { ref, onMounted } from 'vue'
import systemService from '@/services/system.service'

const system = ref([])

onMounted(() => {
    systemService.getInstance()
    .then((response) => {
        system.value = response.data
    })
})

</script>

<template>

<div class="flex w-full">
    <div class="mx-auto my-4 flex gap-8">
        <div>Status : {{ system.status }}</div>
        <div>PHP : {{ system.php }}</div>
        <div>Phalcon : {{ system.version_phalcon }}</div>
        <div>API : {{ system.version_api }}</div>
    </div>
</div>

</template>
